export const ltv = (deposit: number, propertyValue: number) =>
  Math.floor(100 - (deposit / propertyValue) * 100)
